export const STRIPE_BASE_PERCENTAGE = 2.9

export const STRIPE_FIXED_FEE_CENTS = 30

export const STRIPE_INTERNATIONAL_SURCHARGE = 1.5

export const STRIPE_AMEX_SURCHARGE = 0.3

export const CARD_PROCESSING_FEES = {
  defaultCountry: 'US',
  basePercentage: STRIPE_BASE_PERCENTAGE,
  fixedFeeCents: STRIPE_FIXED_FEE_CENTS,
  internationalSurchargePercentage: STRIPE_INTERNATIONAL_SURCHARGE,
  amexSurchargePercentage: STRIPE_AMEX_SURCHARGE,
} as const

export type CardProcessingFees = typeof CARD_PROCESSING_FEES
